<template>
  <div
    v-if="visible"
    class="tasklist-load-progress d-flex align-center"
    :class="{ 'tasklist-load-progress--error': hasError }"
    role="status"
    aria-live="polite"
    :data-testid="testId"
  >
    <span
      v-if="!hasError"
      class="tasklist-load-progress__spinner"
      data-testid="tasklist__load-progress-spinner"
      aria-hidden="true"
    />
    <v-icon
      v-else
      small
      class="tasklist-load-progress__error-icon"
      data-testid="tasklist__load-progress-error-icon"
    >
      mdi-alert-circle-outline
    </v-icon>
    <span
      v-if="showCount"
      class="tasklist-load-progress__label"
      data-testid="tasklist__load-progress-label"
    >
      {{ label }}
    </span>
    <span
      v-if="hasError"
      class="tasklist-load-progress__error"
      data-testid="tasklist__load-progress-error"
    >
      {{ error || progressMessages.PAGE_FAILED }}
    </span>
    <v-btn
      v-if="hasError"
      text
      small
      color="primary"
      class="tasklist-load-progress__retry"
      :loading="retrying"
      data-testid="tasklist__load-progress-retry-btn"
      @click="$emit('retry')"
    >
      {{ progressMessages.RETRY }}
    </v-btn>
    <span class="tasklist-load-progress__hint" data-testid="tasklist__load-progress-hint">
      {{ progressMessages.ACTIONS_LOCKED }}
    </span>
  </div>
</template>

<script>
import './TasklistLoadProgress.scss';
import { TASKLIST_LOAD_MESSAGES, TASKLIST_LOAD_STATUS } from '../../../../../utils/constants';

/**
 * "Loading N of M" while tasklist pages are still arriving, with Retry after a failed page.
 */
export default {
  name: 'TasklistLoadProgress',
  TASKLIST_LOAD_MESSAGES,
  props: {
    loaded: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: TASKLIST_LOAD_STATUS.IDLE,
    },
    error: {
      type: String,
      default: '',
    },
    retrying: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Object,
      default: null,
    },
    testId: {
      type: String,
      default: 'tasklist__load-progress',
    },
  },
  computed: {
    progressMessages() {
      return this.messages || TASKLIST_LOAD_MESSAGES;
    },
    hasError() {
      return this.status === TASKLIST_LOAD_STATUS.ERROR;
    },
    /** Hide "Loading 0 of 0" when the first request failed before a total was known. */
    showCount() {
      return this.total > 0;
    },
    visible() {
      if (this.hasError) return this.total <= 0 || this.loaded < this.total;
      return this.status === TASKLIST_LOAD_STATUS.LOADING && this.total > 0 && this.loaded < this.total;
    },
    label() {
      return this.progressMessages.progress(this.loaded, this.total);
    },
  },
};
</script>
